module.exports = __webpack_public_path__ + "img/logout-image.84f10e8d.svg";